// extracted by mini-css-extract-plugin
export default {"tableDesign":"DataTable_tableDesign__sZpkC","tableLightRow":"DataTable_tableLightRow__8wq7p","tableDarkRow":"DataTable_tableDarkRow__enrNg","narrow":"DataTable_narrow__M-ilE"};